import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-bars-loader',
  imports: [],
  templateUrl: './bars-loader.component.html',
  styleUrl: './bars-loader.component.scss',
})
export class BarsLoaderComponent implements ILoadingOverlayAngularComp {
  agInit(): void {}
}
